import { render, staticRenderFns } from "./MyTariff.vue?vue&type=template&id=71a9711c&scoped=true"
import script from "./MyTariff.vue?vue&type=script&lang=js"
export * from "./MyTariff.vue?vue&type=script&lang=js"
import style0 from "./MyTariff.vue?vue&type=style&index=0&id=71a9711c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9711c",
  null
  
)

export default component.exports